module.exports = __webpack_public_path__ + "487b6e4abf6a44947b732ec3e4265cee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_32.jpg
// module id = 1674
// module chunks = 5